var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _vm.addOpen
        ? _c("add", {
            staticClass: "mb-3",
            attrs: {
              collections: _vm.dataToCreation,
              "copy-from": _vm.copyFrom
            },
            on: {
              "on-cancel": () => {
                this.copyFrom = null
                this.addOpen = false
                this.isAdding = false
              }
            }
          })
        : _vm._e(),
      _c("filter-manager", {
        ref: "filterRef",
        staticClass: "mb-4",
        attrs: { "display-advanced": false, filters: _vm.filtersConfig },
        on: {
          search: function($event) {
            return _vm.onSearchHandler()
          }
        },
        model: {
          value: _vm.filter.model,
          callback: function($$v) {
            _vm.$set(_vm.filter, "model", $$v)
          },
          expression: "filter.model"
        }
      }),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultado" }
      }),
      _vm.results.length == 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No cuenta con información disponible." }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(row) {
        return _c(
          "div",
          { key: row.id },
          [
            _c("result-row", {
              attrs: { data: row },
              on: {
                duplicate: _vm.duplicate,
                reload: _vm.onSearchHandler,
                remove: _vm.remove,
                returnToDraft: _vm.rollbackToDraft
              }
            })
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }